import { render, staticRenderFns } from "./hotBuy.vue?vue&type=template&id=0e71a3c3&scoped=true&"
import script from "./hotBuy.vue?vue&type=script&lang=js&"
export * from "./hotBuy.vue?vue&type=script&lang=js&"
import style0 from "./hotBuy.vue?vue&type=style&index=0&id=0e71a3c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71a3c3",
  null
  
)

export default component.exports